import { apiPatch } from "../client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { IExamPaper } from "./types";

export interface IUpdateExamPaperRequest {
  title: string;
  type?: string;
  difficulty?: number;
  sections: {
    duration: number;
  }[];
}

export const updateExamPaper = async ({
  id,
  data,
}: {
  id: string;
  data: IUpdateExamPaperRequest;
}) => {
  const response = await apiPatch<IExamPaper>(`/exam_papers/${id}`, data);
  return response.data;
};

export const useUpdateExamPaper = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateExamPaper,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["exam_papers"] });
    },
  });
};
